import { configureRetailSdk, DEFAULT_NUMBER_FORMAT_PATTERN } from '@nsftx/seven-nxg-retail-vue-sdk'

export const applyTenantNumberFormat = (decimalFormat?: string | null): void => {
  configureRetailSdk({
    numberFormat: decimalFormat ?? DEFAULT_NUMBER_FORMAT_PATTERN,
  })
}
